import React from 'react';

const LogoZoom = ({ className = "w-12 h-12" }) => (
  <svg className={className} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="12" fill="#2D8CFF"/>
    <path d="M12 20V16C12 14.8954 12.8954 14 14 14H22L30 22V14C30 12.8954 30.8954 12 32 12H34C35.1046 12 36 12.8954 36 14V20C36 21.1046 35.1046 22 34 22H26L18 30V22C18 20.8954 18.8954 20 20 20H12Z" fill="white"/>
    <path d="M20 26L26 32L34 24" stroke="#2D8CFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default LogoZoom;
